export default {
      id: "social-twitter-usage",
      viewBox: "0 0 20 17",
      url: __webpack_public_path__ + "sprite.svg#social-twitter",
      toString: function () {
        return this.url;
      }
    }


//////////////////
// WEBPACK FOOTER
// ./src/assets/icons/social-twitter.svg
// module id = 139
// module chunks = 241 242 243